<div class="boolean__icon">
  <i *ngIf="isTrue()" class="icon icon__cell ion-ios-checkmark"></i>
  <i *ngIf="!isTrue()" class="icon icon__cell ion-ios-close"></i>
</div>
